var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMateriales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19872 0.587523C8.69705 0.310669 9.303 0.31067 9.80134 0.587523L17.0013 4.58752C17.5252 4.87853 17.85 5.43066 17.85 6.02988V13.9708C17.85 14.57 17.5252 15.1221 17.0013 15.4131L9.80134 19.4131C9.303 19.69 8.69705 19.69 8.19872 19.4131L0.998713 15.4131C0.474894 15.1221 0.150024 14.57 0.150024 13.9708V6.02988C0.150024 5.43066 0.474896 4.87853 0.998714 4.58752L8.19872 0.587523ZM9.07287 1.89876C9.02757 1.87359 8.97248 1.87359 8.92718 1.89876L1.72718 5.89876C1.67956 5.92522 1.65002 5.97541 1.65002 6.02988V13.9708C1.65002 14.0252 1.67956 14.0754 1.72718 14.1019L8.92718 18.1019C8.97248 18.1271 9.02757 18.1271 9.07287 18.1019L16.2729 14.1019C16.3205 14.0754 16.35 14.0252 16.35 13.9708V6.02988C16.35 5.97541 16.3205 5.92521 16.2729 5.89876L9.07287 1.89876Z",
    fill: "#AFAFB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25002 10.0003C4.25002 7.37697 6.37667 5.25032 9.00002 5.25032C11.6234 5.25032 13.75 7.37697 13.75 10.0003C13.75 12.6237 11.6234 14.7503 9.00002 14.7503C6.37667 14.7503 4.25002 12.6237 4.25002 10.0003ZM9.00002 6.75032C7.2051 6.75032 5.75002 8.20539 5.75002 10.0003C5.75002 11.7952 7.2051 13.2503 9.00002 13.2503C10.795 13.2503 12.25 11.7952 12.25 10.0003C12.25 8.20539 10.795 6.75032 9.00002 6.75032Z",
    fill: "#AFAFB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMateriales);
export default __webpack_public_path__ + "static/media/materiales.ad25136a09dbdda554b6458058d988e0.svg";
export { ForwardRef as ReactComponent };